import React, { useRef, useState,useEffect } from "react";
import { LogOut, Star } from "react-feather";
import { Link } from "react-router-dom";
import useOnClickOutside from "../../../hooks/useOnClickOutside";
import {
  logo,logopcp,  MyProfile,User15 ,ZoomIcon, FolderIcon
} from "../../imagepath";
import { signOut } from '../../../lib/auth'
import { getIdData } from "../../../lib/studentinfo";
import StudentInfoBox from "../studentInfo/studentinfobox";
import {getFile } from "../../../lib/file"
import {useAuth} from "../../../usercontext";
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { getCompanyLogo } from '../../../lib/company'
//import { clippingParents } from "@popperjs/core";

// eslint-disable-next-line react/prop-types
export function InstructorHeader({ activeMenu, mobileMenu, setMobileMenu }) {
	const [navbar, setNavbar] = useState(false)
	const { profile } = useAuth()
	const [companyLogo, setCompanyLogo] = useState('/defaultlogo.png')
	const navigate = useNavigate()
	const [avatar, setAvatar] = useState('')
	const [showStudent, setShowStudent] = useState(false)
	const [studentInfo, setStudentInfo] = useState()
	const [isStudent911, setisStudent911] = useState(false)
	const [isStudent12, setisStudent12] = useState(false)
	let { slug } = useParams()

	const [showCart, setShowCart] = useState(false)
	const [showWish, setShowWish] = useState(false)
	const [showNotification, setShowNotification] = useState(false)
	const [showProfile, setShowProfile] = useState(false)

	// Mobile Menu toggle
	/* const [mobileMenu, setMobileMenu] = useState(false); */
	const [mobileSubMenu, setMobileSubMenu] = useState(false)
	const [mobileSubMenu2, setMobileSubMenu2] = useState(false)
	const [mobileSubMenu22, setMobileSubMenu22] = useState(false)
	const [mobileSubMenu3, setMobileSubMenu3] = useState(false)
	const [mobileSubMenu32, setMobileSubMenu32] = useState(false)
	const [mobileSubMenu4, setMobileSubMenu4] = useState(false)
	const [mobileSubMenu42, setMobileSubMenu42] = useState(false)
	const [mobileSubMenu43, setMobileSubMenu43] = useState(false)
	const [mobileSubMenu5, setMobileSubMenu5] = useState(false)

	const handleSignOut = async (e) => {
		const error = await signOut()

		navigate('/login')
	}

	async function GetData() {
		const avt = await getFile(profile.avatar_url)
		setAvatar(avt.publicUrl)
	}

	async function GetStudentData() {
		const info = await getIdData(slug)
		setStudentInfo(info)
		if (info[0].role === 'Student911') {
			//console.log("info", info[0].role);
			setisStudent911(true)
			setisStudent12(false)
		} else if (info[0].role === 'Student12') {
			//console.log("info", info[0].role);
			setisStudent12(true)
			setisStudent911(false)
		}

		//console.log("info", isStudent911,isStudent12);
	}

	useEffect(() => {
		GetData()
	}, [profile])

	function isValidUUID(uuid) {
		const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
		return regex.test(uuid)
	}

	useEffect(() => {
		console.log('slug', slug)

		if (isValidUUID(slug)) {
			GetStudentData()
			setShowStudent(true)
		} else setShowStudent(false)
	}, [slug])

	const openMobileMenu = () => {
		document.body.classList.add('menu-opened')
		setMobileMenu(true)
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}
	const hideMobileMenu = () => {
		document.body.classList.remove('menu-opened')
		setMobileMenu(false)
	}

	const openMobileSubMenu = (e) => {
		e.preventDefault()
		setMobileSubMenu(!mobileSubMenu)
	}
	const openMobileSubMenu2 = (e) => {
		e.preventDefault()
		setMobileSubMenu2(!mobileSubMenu2)
	}
	const openMobileSubMenu22 = (e) => {
		e.preventDefault()
		setMobileSubMenu22(!mobileSubMenu22)
	}
	const openMobileSubMenu3 = (e) => {
		e.preventDefault()
		setMobileSubMenu3(!mobileSubMenu3)
	}
	const openMobileSubMenu32 = (e) => {
		e.preventDefault()
		setMobileSubMenu32(!mobileSubMenu32)
	}
	const openMobileSubMenu4 = (e) => {
		e.preventDefault()
		setMobileSubMenu4(!mobileSubMenu4)
	}
	const openMobileSubMenu42 = (e) => {
		e.preventDefault()
		setMobileSubMenu42(!mobileSubMenu42)
	}
	const openMobileSubMenu43 = (e) => {
		e.preventDefault()
		setMobileSubMenu43(!mobileSubMenu43)
	}
	const openMobileSubMenu5 = (e) => {
		e.preventDefault()
		setMobileSubMenu5(!mobileSubMenu5)
	}
	// To close the modal, when clicked outside anywhere
	const cart = useRef()
	useOnClickOutside(cart, () => setShowCart(false))

	const wish = useRef()
	useOnClickOutside(wish, () => setShowWish(false))

	const notification = useRef()
	useOnClickOutside(notification, () => setShowNotification(false))
	/*
  const profile = useRef();
  useOnClickOutside(profile, () => setShowProfile(false));
*/
	// Cart Click
	const cartClick = (e) => {
		e.preventDefault()
		// if (showWish) {
		//   setShowWish(false);
		// }
		setShowCart(!showCart)
		console.log(showCart)
	}

	const wishClick = (e) => {
		e.preventDefault()
		// if (showCart) {
		//   setShowCart(false);
		// }
		setShowWish(!showWish)
	}

	const notificationClick = (e) => {
		e.preventDefault()
		setShowNotification(!showNotification)
	}
	const profileClick = (e) => {
		e.preventDefault()
		setShowProfile(!showProfile)
	}

	const changeHeaderBackground = () => {
		if (window.scrollY >= 60) {
			setNavbar(true)
		} else {
			setNavbar(false)
		}
	}
	window.addEventListener('scroll', changeHeaderBackground)

	useEffect(() => {
		const fetchLogo = async () => {
			if (profile && profile.companyId) {
				const logoUrl = await getCompanyLogo(profile.companyId)
				setCompanyLogo(logoUrl)
			}
		}
		fetchLogo()

		// Listen for the custom event
		const handleLogoUpdate = (event) => {
			setCompanyLogo(event.detail.logoUrl)
		}

		window.addEventListener('logoUpdated', handleLogoUpdate)

		// Cleanup event listener on component unmount
		return () => {
			window.removeEventListener('logoUpdated', handleLogoUpdate)
		}
	}, [profile, profile?.companyId])

	return (
		<header className="header header-instructor-page">
			{/* Modal */}
			{showStudent && studentInfo && (
				<div
					className="modal fade modal-lg"
					id="staticBackdrop"
					data-bs-backdrop="static"
					data-bs-keyboard="false"
					tabIndex="-1"
					aria-labelledby="staticBackdropLabel"
					aria-hidden="true"
				>
					<div className="modal-dialog">
						<div className="modal-content">
							<div className="modal-header">
								<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
							</div>
							<div className="modal-body">
								<StudentInfoBox slug={slug} />
							</div>
						</div>
					</div>
				</div>
			)}
			{/*<div className='header-fixed'>*/}
			<div>
				<nav
					className={
						navbar
							? 'navbar navbar-expand-lg header-instructor-nav scroll-sticky add-header-bg'
							: 'navbar navbar-expand-lg header-instructor-nav scroll-sticky'
					}
				>
					<div className="container-fluid mx-5">
						<div className="navbar-header">
							<span id="mobile_btn" onClick={openMobileMenu} className={`${mobileMenu ? 'd-none' : 'd-block cursor_pointer'}`}>
								<span className="bar-icon">
									<span></span>
									<span></span>
									<span></span>
								</span>
							</span>
							<Link to="/" className={`navbar-brand logo ${!mobileMenu ? 'text-center' : 'text-start'}`}>
								<img
									src={companyLogo}
									className="img-fluid"
									alt="Logo"
									style={{
										maxHeight: '70px',
										width: 'auto',
										objectFit: 'contain',
										opacity: '1',
										transition: 'opacity 0.3s ease-in-out'
									}}
								/>
							</Link>
						</div>
						{/* Instructor Menu Start */} {/* d-none class ı verdim */}
						<div className="d-flex justify-content-start">
							<div className="main-menu-wrapper ">
								<div className="menu-header">
									<Link to="/" className="menu-logo">
										<img src={logo} className="img-fluid" alt="Logo" />
									</Link>
									<Link id="menu_close" className="menu-close" to="#;" onClick={hideMobileMenu}>
										<i className="fas fa-times"></i>
									</Link>
								</div>
								<ul className="main-nav">
									<li className="has-submenu">
										<Link className={mobileSubMenu ? 'submenu' : ''} to="/instructor/instructor-class" onClick={openMobileSubMenu}>
											Instructor <i className="fas fa-chevron-down" />
										</Link>
										<ul style={{ zIndex: 10000 }} className={mobileSubMenu ? 'submenu submenuShow' : 'submenu'}>
											<li className="nav-item">
												<Link to="/instructor/instructor-class" className={'nav-item'}>
													Class List
												</Link>
											</li>
											<li className="nav-item">
												<Link to="/instructor/instructor-scheduledays" className={'nav-item'}>
													Schedule
												</Link>
											</li>
											<li className="nav-item">
												<Link to="/instructor/instructor-desiredcolleges" className={'nav-item'}>
													College List
												</Link>
											</li>

											<li className="nav-item">
												<Link to="/instructor/instructor-taskmanage" className={'nav-item'}>
													Class Task
												</Link>
											</li>
											<li className="nav-item">
														<Link to={`/instructor/instructor-studentresource/${slug}`} className={'nav-item'}>
															Resource
														</Link>
													</li>
										</ul>
									</li>
								</ul>
							</div>
						</div>
						<div className="p-2 d-flex">
							{showStudent && studentInfo && (
								<>
									<div className="m-4 vr"></div>
									<div className="my-auto">
										<h5>
											{studentInfo[0].name + ' ' + studentInfo[0].surname}{' '}
											<button type="button" className="btn btn-outline-info" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
												<svg
													xmlns="http://www.w3.org/2000/svg"
													width="15"
													height="15"
													fill="currentColor"
													className="bi bi-chevron-double-down"
													viewBox="0 0 16 16"
												>
													<path
														fillRule="evenodd"
														d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
													/>
													<path
														fillRule="evenodd"
														d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
													/>
												</svg>
											</button>
										</h5>
									</div>
									<div className="my-auto p-3">
										<Link to={studentInfo[0].meetlink} target="_blank">
											<span className="">
												<img src={ZoomIcon} alt="" style={{ width: '36px' }} />
											</span>
										</Link>
										<Link to={studentInfo[0].folderlink} target="_blank">
											<span className="">
												<img src={FolderIcon} alt="" style={{ width: '36px' }} />
											</span>
										</Link>
									</div>
									<div className="main-menu-wrapper m-4">
									{isStudent911 && (
														
															<Link to={`/instructor-student-profile/${slug}`} className={'nav-item'}>
																College Profile
															</Link>
														
													)}
													{isStudent12 && (
														
															<Link to={`/instructor-student-profile_2/${slug}`} className={'nav-item'}>
																App. Profile
															</Link>
														
													)}
													</div>
{/*}
									<div className="main-menu-wrapper m-4">
										<ul className="main-nav">
											<li className="has-submenu">
												<Link className={mobileSubMenu ? 'submenu' : ''} to="/instructor/instructor-class" onClick={openMobileSubMenu}>
													Student <i className="fas fa-chevron-down" />
												</Link>
												<ul style={{ zIndex: 10000 }} className={mobileSubMenu ? 'submenu submenuShow' : 'submenu'}>
													{/*}
                <li className='nav-item'>
                    <Link
                     to={`/instructor/instructor-studentschedule/${slug}`}
                      className={'nav-item'}
                    >
                      Schedule               
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <Link
                      to={`/instructor/instructor-studenttask/${slug}`}
                      className={'nav-item'}
                    >
                      Task                 
                    </Link>
                  </li>                           
             */}
										{/*}			
													{isStudent911 && (
														<li className="nav-item">
															<Link to={`/instructor-student-profile/${slug}`} className={'nav-item'}>
																College Profile
															</Link>
														</li>
													)}
													{isStudent12 && (
														<li className="nav-item">
															<Link to={`/instructor-student-profile_2/${slug}`} className={'nav-item'}>
																App. Profile
															</Link>
														</li>
													)}
												</ul>
											</li>
										</ul>
									</div>
									{*/}
									<div className="m-4 vr"></div>
								</>
							)}
						</div>
						<div>
							<ul className="nav header-navbar-rht">
								<li className="nav-item user-nav">
									<Link to="#" className={showProfile ? 'dropdown-toggle show' : 'dropdown-toggle'} data-bs-toggle="dropdown" onClick={profileClick}>
										<span className="user-img">
											<img src={MyProfile} alt="" />
											<span className="status online"></span>
										</span>
									</Link>
									<div
										ref={profile}
										style={{ zIndex: 10000 }}
										className={showProfile ? 'users dropdown-menu dropdown-menu-right show modalPosition' : 'users dropdown-menu dropdown-menu-right'}
										data-popper-placement="bottom-end"
									>
										<div className="user-header">
											<div className="avatar avatar-sm">
												<img src={avatar ? avatar : User15} alt="User Image" className="avatar-img rounded-circle" />
											</div>
											<div className="user-text">
												<h6>{profile.name + ' ' + profile.surname}</h6>
												<p className="text-muted text mb-0">Instructor</p>
											</div>
										</div>
										{/*}
                  <Link
                    className="dropdown-item text"
                    to="/instructor-dashboard"
                  >
                    <Home size={14} color={"#FF875A"} className="headerIcon" />{" "}
                    Dashboard
                  </Link>
                */}
										<Link className="dropdown-item text" to="/instructor/instructor-profile">
											<Star size={14} color={'#FF875A'} className="headerIcon" /> Edit Profile
										</Link>
										{/*}
                  <div className="dropdown-item text night-mode">
                    <span>
                      <Moon size={14} className="headerIcon" /> Night Mode{" "}
                    </span>
                    <div className="form-check form-switch check-on m-0">
                      <input
                        className="form-check-input focusShadow"
                        type="checkbox"
                        id="night-mode"
                      />
                    </div>
                  </div>
                  */}
										<Link className="dropdown-item text" onClick={handleSignOut}>
											<LogOut size={14} color={'#FF875A'} className="headerIcon" /> Sign Out
										</Link>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</nav>
				<div className={mobileMenu ? 'sidebar-overlay opened' : 'sidebar-overlay'}></div>
			</div>
		</header>
	)
}
